<template>
  <div class="dialog_box">
    <el-dialog title="用户详情" :visible="show" width="878px" @close="confirm" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <div class="module_box">
          <div class="form_title" style="margin-bottom:10px;">基本信息</div>
          <div class="content_box">
            <div>企业名称：</div>
            <div>{{ data.orgName }}</div>
          </div>
          <div class="content_box">
            <div>企业简称：</div>
            <div>{{ data.orgSimpleName }}</div>
          </div>
          <div class="content_box">
            <div>统一社会信用代码：</div>
            <div>{{ data.creditCode }}</div>
          </div>
          <div class="content_box">
            <div>企业负责人：</div>
            <div>{{ data.head }}</div>
          </div>
          <div class="content_box">
            <div>企所属区域：</div>
            <div>{{ data.areaName }}</div>
          </div>
          <div class="content_box">
            <div>负责人手机号：</div>
            <div>{{ data.phone }}</div>
          </div>
          <div class="content_box">
            <div>详细地址：</div>
            <div>{{ data.addr }}</div>
          </div>

          <div class="form_title" style="margin:10px 0;">车辆/终端信息</div>
          <div class="content_box">
            <div>车辆总数：</div>
            <div>{{ data.carNum }}</div>
          </div>
          <div class="content_box">
            <div>终端总数：</div>
            <div>{{ data.terNum }}</div>
          </div>

          <div class="form_title" style="margin:10px 0;">工单信息</div>
          <div class="content_box">
            <div>新装工单（车辆）：</div>
            <div>{{ data.addOrderNum }}</div>
          </div>
          <div class="content_box">
            <div>维护工单（车辆）：</div>
            <div>{{ data.updateOrderNum }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      imgUrl: ""
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show (val) {
      if (val) {
      }
    },
  },
  created () { },
  methods: {
    confirm () {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-form-item__content {
  width: 240px;
}

/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: visible !important;
}

.form_location {
  position: relative;

  .hint {
    position: absolute;
    top: 45px;
    left: 0;
    font-size: 12px;
    color: #999;
    white-space: nowrap;
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/company_Admin/component/detail.vue